import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.6 5.8c-.3.3-.9.3-1.2 0l-.6-.6c-.6-.6-1.5-1-2.6-1-2 0-3.7 1.6-3.7 3.7 0 2 1 3.6 2.6 5a17 17 0 0 0 4.5 2.7h.8a17 17 0 0 0 4.5-2.7c1.5-1.4 2.6-3 2.6-5a3.8 3.8 0 0 0-6.3-2.7zM10 4A5.4 5.4 0 0 0 .8 8c0 5.2 5.8 8.2 8.2 9.1.6.3 1.3.3 2 0 2.4-1 8.2-3.9 8.2-9.2A5.4 5.4 0 0 0 10 4"
    }, null, -1)
  ]))]))
}
export default { render: render }